const initialEditingContext = null;

export default initialEditingContext;
